import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

// ============================================
// Container
// ============================================
export const DeleteModalContainer = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '32px',
  padding: '32px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '-4px -4px 12px 0px rgba(0,0,0,0.08), 4px 4px 12px 0px rgba(0,0,0,0.08)',
});

// ============================================
// Content
// ============================================
export const DeleteModalContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const DeleteModalTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: 700,
  color: '#262626',
  textAlign: 'center',
  lineHeight: 1.5,
});

export const DeleteModalTitleHighlight = styled('span')({
  fontSize: '24px',
  color: '#EE735A',
});

// ============================================
// Buttons
// ============================================
export const DeleteModalButtonGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
});

export const DeleteModalCancelButton = styled(Button)({
  width: '120px',
  height: '48px',
  padding: '12px 24px',
  borderRadius: '8px',
  backgroundColor: '#D9D9D9',
  fontSize: '20px',
  fontWeight: 600,
  color: '#404040',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#c9c9c9',
  },
});

export const DeleteModalConfirmButton = styled(Button)({
  width: '180px',
  height: '48px',
  padding: '12px 24px',
  borderRadius: '8px',
  backgroundColor: '#EE735A',
  fontSize: '20px',
  fontWeight: 600,
  color: '#fff',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#d9654d',
  },
});
